import applyOnlineService from '../api/services/applyOnlineService'
import moment from 'moment/moment'
import baseApi from '../api/common/baseApi.js'

const fillObject = {
	fillProduct(obj, summary, frequencySelected) {
		//#region create & fill summary field in formData object
		obj.productName = summary.productSelected.productName

		obj.areaOfCoverId = summary.areaSelected.areaOfCoverID
		obj.areaOfCoverName = summary.areaSelected.areaOfCoverName
		obj.areaOfCoverCountryXrefEndorsement = summary.areaSelected.areaOfCoverCountryXrefEndorsement

		obj.levelOfCoverName = summary.levelOfCover.levelOfCoverName

		obj.voluntaryExcessId = summary.voluntaryExcessSelected.voluntaryExcessID
		obj.voluntaryExcessName = summary.voluntaryExcessSelected.voluntaryExcessName
		obj.voluntaryExcessEndorsement = summary.voluntaryExcessSelected.voluntaryExcessEndorsement

		obj.mandatoryExcesses = summary.productSelected.mandatoryExcesses
			? summary.productSelected.mandatoryExcesses
			: []

		// co-insurance
		summary.coInsuranceSelected.forEach((coInsure) => {
			if (obj.coInsurances.findIndex((v) => v.coInsureName === coInsure.coInsureName) < 0) {
				obj.coInsurances.push({
					coInsureId: coInsure.coInsureId,
					coInsureName: coInsure.coInsureName,
					coInsuranceEndorsement: coInsure.coInsureEndorsement,
				})
			}
		})

		var displayBenefits = []
		summary.additionalBenefitsSelected.forEach((benefit) => {
			if (displayBenefits.findIndex((i) => i.benefitName == benefit.benefitName) < 0) {
				displayBenefits.push(benefit)
			}
		})
		obj.benefits = displayBenefits

		obj.frequencySelected = frequencySelected

		let selectedProductCurrency = summary.productSelected.currencies.find((v) => v.isSelected === true)
		obj.currency = selectedProductCurrency

		//#endregion
	},

	fillSummary(obj, summary, frequencySelected) {
		//#region create & fill summary field in formData object
		obj.productName = summary.productSelected.productName
		obj.areaOfCoverName = summary.areaSelected.areaOfCoverName
		obj.areaOfCoverCountryXrefEndorsement = summary.areaSelected.areaOfCoverCountryXrefEndorsement

		obj.levelOfCoverName = summary.levelOfCover.levelOfCoverName

		obj.voluntaryExcessName = summary.voluntaryExcessSelected.voluntaryExcessName
		obj.voluntaryExcessEndorsement = summary.voluntaryExcessSelected.voluntaryExcessEndorsement

		obj.mandatoryExcesses = summary.productSelected.mandatoryExcesses
			? summary.productSelected.mandatoryExcesses
			: []

		// co-insurance
		obj.coInsurances = []
		// co-insurance
		summary.coInsuranceSelected.forEach((coInsure) => {
			if (obj.coInsurances.findIndex((v) => v.coInsureName === coInsure.coInsureName) < 0) {
				obj.coInsurances.push({
					coInsureId: coInsure.coInsureId,
					coInsureName: coInsure.coInsureName,
					coInsuranceEndorsement: coInsure.coInsureEndorsement,
				})
			}
		})

		var displayBenefits = []
		summary.additionalBenefitsSelected.forEach((benefit) => {
			if (displayBenefits.findIndex((i) => i.benefitName == benefit.benefitName) < 0) {
				displayBenefits.push(benefit)
			}
		})
		obj.benefits = displayBenefits

		obj.frequencySelected = frequencySelected

		let selectedProductCurrency = summary.productSelected.currencies.find((v) => v.isSelected === true)
		obj.currency = selectedProductCurrency
		//#endregion
	},

	fillUnderwritingType(obj, summary) {
		const underwriting = summary.productSelected.underwritingTypes.find(
			(e) => e.underwritingTypeId === obj.underwritingTypeId,
		)

		obj.underwritingTypeName = underwriting ? underwriting.underwritingTypeName : ''
		obj.underwritingTermsEndorsement = underwriting ? underwriting.underwritingTermsEndorsement : ''
	},

	/**
	 *
	 * @param {*} obj formCopyData
	 * @param {*} formData formData.policyHolder.details
	 * @param {*} optionData
	 * @param {*} policy
	 * @param {*} policyHolderInsured
	 */
	fillPolicy(obj, formData, optionData, policy = true, policyHolderInsured = true) {
		if (policy) {
			// contact details
			obj.policyHolder.contactDetails.lineNumberCountryCodeName =
				optionData.countryCodes.find((v) => v.value == obj.policyHolder.contactDetails.lineNumberCountryCodeId)
					.text || ''
			obj.policyHolder.contactDetails.countryCodeMobileName =
				optionData.countryCodes.find((v) => v.value == obj.policyHolder.contactDetails.countryCodeMobileId)
					.text || ''

			obj.policyDetails.currencyName =
				optionData.currencies.find((v) => v.value == obj.policyDetails.currencyId).text || ''
		}

		let details,
			additionalDetails = {}

		if (policy) {
			// obj.policyHolder.details.dateOfBirth = moment(obj.policyHolder.details.dateOfBirth, 'D-M-Y').format(
			// 	'DD-MM-YYYY',
			// )
			details = obj.policyHolder.details
			additionalDetails = obj.policyHolder.additionalDetails
		} else {
			details = obj.details
			additionalDetails = obj.additionalDetails
		}

		this.fillPolicyDetail(details, formData, optionData, policy)
		if (!(policy && !policyHolderInsured)) this.fillAdditionalDetail(additionalDetails, optionData, policy)
	},

	/**
	 * Fill policy details
	 * @param {*} obj
	 * @param {*} optionData
	 * @param {*} policy
	 * @param {*} quoteResponse VerifyQuote response object
	 */
	fillPolicyDetail(obj, formData, optionData, policy = true) {
		if (obj.salutationId && obj.salutationId != -1) {
			obj.salutationName = optionData.titles.find((v) => v.value == obj.salutationId).text || ''
		}

		obj.genderName = optionData.genders.find((v) => v.value == obj.genderId).text || ''

		if (policy) {
			obj.countryOfResidence = {
				residenceCountryId: formData.residenceCountryId,
				residenceCountryName:
					optionData.residenceCountries.find((v) => v.value == formData.residenceCountryId).text || '',
				residenceCountryEndorsement:
					optionData.residenceCountries.find((v) => v.value == formData.residenceCountryId).field2 || '',
			}
		}

		obj.nationality = {
			countryId: formData.nationalityCountryId,
			countryName: optionData.nationalities.find((v) => v.value == formData.nationalityCountryId).text || '',
		}

		obj.occupationName = optionData.occupations.find((v) => v.value == obj.occupationId).text || ''

		if (!policy) {
			obj.relationshipToPolicyHolder.relationshipName =
				optionData.relationships.find((v) => v.value == obj.relationshipId).text || ''

			obj.relationshipToPolicyHolder.relationshipToPolicyHolderId = obj.relationshipId

			delete obj.relationshipId
			delete obj.relationshipName
		}
	},

	fillAdditionalDetail(obj, optionData, policy = true) {
		obj.pastimeName = optionData.pastimes.find((v) => v.value == obj.pastimeId).text || ''

		if (policy) {
			obj.countryResidenceAddress.countryCodeName =
				optionData.countries.find((v) => v.value == obj.countryResidenceAddress.countryId).text || ''
		}

		if (policy) {
			obj.homeCountryAddress.countryCodeName =
				optionData.countries.find((v) => v.value == obj.homeCountryAddress.countryId).text || ''
		}

		if (obj.physicianDetails.salutationId && obj.physicianDetails.salutationId != -1) {
			obj.physicianDetails.salutationName =
				optionData.titles.find((v) => v.value == obj.physicianDetails.salutationId).text || ''
		}

		if (obj.physicianDetails.countryCodeId && obj.physicianDetails.countryCodeId != -1) {
			obj.physicianDetails.countryCodeName =
				optionData.titles.find((v) => v.value == obj.physicianDetails.salutationId).text || ''
		}

		if (obj.physicianDetails.address.countryId && obj.physicianDetails.address.countryId != -1) {
			obj.physicianDetails.address.countryName =
				optionData.countries.find((v) => v.value == obj.physicianDetails.address.countryId).text || ''
		}
	},

	/**
	 * Fill insurer details information
	 * @param {*} obj - formDataCopy
	 * @param {*} productId
	 * @param {*} productName
	 */
	// fillInsurerDetails(obj, productId, productName) {
	// 	applyOnlineService
	// 		.getInsurerDetailsAsync(productId, productName, obj.policyDetails.policyStartDate)
	// 		.then((insurerDetails) => {
	// 			obj.insurerId = insurerDetails.insurerCompanyId
	// 			obj.insurerCompanyName = insurerDetails.mgaCompanyDetailsJson.companyName || ''
	// 		})
	// 		.catch(() => {
	// 			;(obj.insurer = -1), (obj.insurerCompanyName = '')
	// 		})
	// },

	fillPaymentFrequency(formDataCopy, summary) {
		const paymentFrequencies = JSON.parse(JSON.stringify(summary.levelOfCover.premiumsAsPerPaymentFrequency))

		paymentFrequencies.premiumBreakdownByPaymentFrequency =
			paymentFrequencies.premiumBreakdownByPaymentFrequency.find(
				(paymentFrequency) =>
					paymentFrequency.paymentFrequencyID == summary.frequencySelected.paymentFrequencyID,
			)

		paymentFrequencies.insuredsAnnualPremiumsAsPerPaymentFrequency =
			paymentFrequencies.insuredsAnnualPremiumsAsPerPaymentFrequency.find(
				(paymentFrequency) =>
					paymentFrequency.paymentFrequencyID == summary.frequencySelected.paymentFrequencyID,
			)

		var insuredPremiumBreakdownByPaymentFrequency = paymentFrequencies.insuredPremiumBreakdownByPaymentFrequency
		for (const key in insuredPremiumBreakdownByPaymentFrequency) {
			insuredPremiumBreakdownByPaymentFrequency[key] = insuredPremiumBreakdownByPaymentFrequency[key].find(
				(v) => v.paymentFrequencyID === summary.frequencySelected.paymentFrequencyID,
			)
		}

		formDataCopy.premiumsAsPerPaymentFrequency = paymentFrequencies
	},

	/**
	 * 	Fill underwriting questions
	 * @param {array} obj formData - underwriting questions list
	 */
	async fillUnderwritingQuestionsAsync(obj, productId, underwritingTypeId, locale, policyStartDate, optionData) {
		if (!obj.underwritingQuestions.length) {
			obj.underwritingQuestionGroups = []
			return
		}

		const params = new URLSearchParams([
			['productId', productId],
			['underwritingTypeId', underwritingTypeId],
			['culture', locale],
			['selectedDate', policyStartDate],
		])

		let formattedQuestions = []

		obj.underwritingQuestions.forEach((v) => {
			formattedQuestions.push({
				underwritingQuestionId: v.questionId,
				underwritingQuestionNumber: v.questionNumber,
				underwritingQuestion: v.question,
				isAnswer: v.isAnswer,
				answers: v.answer == null ? [] : this.handleAnswer(v.answer, optionData),
			})
		})

		const groupQuestionFormatted = []
		const questionGroup = await baseApi.get(`api/underwritingQuestions?${params}`)
		questionGroup.forEach((g) => {
			const underwritingQuestionGroup = {
				underwritingQuestionGroupId: g.underwritingQuestionGroupId,
				underwritingQuestionGroupName: g.underwritingQuestionGroupName,
				underwritingQuestionGroupNumber: g.underwritingQuestionGroupNumber,
				underwritingQuestions: this.mappingQuestion(g.underwritingQuestions, formattedQuestions),
			}

			groupQuestionFormatted.push(underwritingQuestionGroup)
		})

		obj.underwritingQuestionGroups = groupQuestionFormatted

		delete obj.underwritingQuestions
	},

	/**
	 *
	 * @param {*} groupQuestion question in question group
	 * @param {*} questionDisplay underwritingQuestion in formData
	 */
	mappingQuestion(groupQuestion, questionDisplay) {
		const underwritingQuestions = []
		if (groupQuestion.length && questionDisplay.length)
			groupQuestion.forEach((g) => {
				underwritingQuestions.push(
					questionDisplay.find((v) => g.underwritingQuestionId === v.underwritingQuestionId),
				)
			})

		return underwritingQuestions
	},

	/* A method that is used to find the text of a conditionId. */
	handleAnswer(answers, optionData) {
		//loop through the answers
		answers.forEach((answer) => {
			if (answer.dateEnded == null) answer.dateEnded = ''

			if (answer.currentConditionId) {
				const condition = optionData.currentConditions.find((v) => v.value == answer.currentConditionId)

				answer.currentCondition = condition.text || ''
			}
		})

		return answers
	},
}

export default fillObject
